var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-radio-group',{on:{"change":_vm.doChange},model:{value:(_vm.selection),callback:function ($$v) {_vm.selection=$$v},expression:"selection"}},[_c('el-radio-button',{staticClass:"tools-button",attrs:{"label":_vm.labels.material}}),_c('el-radio-button',{staticClass:"tools-button",attrs:{"label":_vm.labels.window}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }